import setSuggestedContacts from './setSuggestedContacts';
import datapoints from '../datapoints';
import type AtMentionsViewState from '../store/schema/AtMentionsViewState';
import {
    PerformanceDatapoint,
    returnTopExecutingActionDatapoint,
    wrapFunctionForDatapoint,
} from 'owa-analytics';
import { mutatorAction } from 'satcheljs';
import { lazyFindReadWriteRecipient } from 'owa-readwrite-recipient-well';
import type ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';

export default wrapFunctionForDatapoint(
    datapoints.MentionsFindPeople,
    async function findReadWriteRecipient(
        viewState: AtMentionsViewState,
        queryString: string,
        searchDirectory: boolean,
        currentWellContents?: ReadWriteRecipientViewState[]
    ): Promise<void> {
        let datapoint: PerformanceDatapoint;
        setAtMentionQueryString(viewState, queryString);
        if (!queryString) {
            setSuggestedContacts(viewState, currentWellContents);
            datapoint = returnTopExecutingActionDatapoint();
            if (datapoint) {
                datapoint.addCustomData({ zeroState: true.toString() });
            }
        } else {
            await lazyFindReadWriteRecipient.importAndExecute(
                viewState,
                queryString,
                searchDirectory,
                false /*resolveIfSingle*/,
                null /*recipentsToExclude*/,
                currentWellContents,
                'forceOn' /*searchCacheFirstOverride*/
            );
            const sameQueryString = viewState.queryString.trim() == queryString;
            if (sameQueryString) {
                resetAtMentionSelectedIndex(viewState);
            }
            datapoint = returnTopExecutingActionDatapoint();
            if (datapoint) {
                datapoint.addCustomData({
                    zeroState: false.toString(),
                    sameQueryString: sameQueryString.toString(),
                    searchDirectory: searchDirectory.toString(),
                });
            }
        }
    }
);

const setAtMentionQueryString = mutatorAction(
    'setAtMentionQueryString',
    (viewState: AtMentionsViewState, queryString: string) => {
        viewState.queryString = queryString;
    }
);

const resetAtMentionSelectedIndex = mutatorAction(
    'resetAtMentionSelectedIndex',
    (viewState: AtMentionsViewState) => {
        viewState.selectedRecipientIndex = 0;
    }
);
